module.exports = __webpack_public_path__ + "img/notification-bell-desktop-fr.fdd5b2bf.jpg";